export const TABLE = {
  HEIGHT: 20,
  WIDTH: 10,
  CELL: {
    SIZE: (isBig: boolean) => (isBig ? 32 : 25),
  },
};
